var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('clinicList',{attrs:{"canEdit":true,"editRoute":"AdminClinicEdit","canCreate":true,"createRoute":"AdminClinicCreate","canViewDetail":true,"viewRoute":"AdminClinicDetail","canViewClinicTreatmentHistory":true,"clinicTreatmentHistoryRoute":"AdminClinicTreatmentHistory"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }